






























































































































































// Vue
import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import {mapActions, mapGetters} from 'vuex';
import {Mixins} from 'vue-mixin-decorator';

// Components
import ClientFilter from '@/manager/client/views/partial/client-filter/client-filter.view.vue';
import ParticipantClientCsvModal
    from '@/manager/convocation/views/convocationDetail/participantClientCsvModal/participantClientCsvModal.view.vue';
import ItemThumb from '@/shared/components/item-thumb.component.vue';
import Search from '@/shared/components/search.component.vue';
import Pagination from '@/shared/components/Pagination/Pagination.component.vue';
import Btn, {BtnColor, BtnWidth, BtnPredefinedStyle} from '@/shared/components/btn.component.vue';
import TopBar from '@/shared/components/TopBar.component.vue';
import Icon, {IconEnum} from '@/shared/components/icon.component.vue';
import EmptyState from '@/shared/components/empty-state.component.vue';
import Spinner from '@/shared/components/Spinner.component.vue';
import SpotlightText, {SpotlightTextColor} from '@/shared/components/SpotlightText.component.vue';

// Mixins
import SearchMixin from '@/shared/mixins/search.mixin.ts';
import WithPagination from '@/shared/mixins/withPagination.mixin.ts';
import NotificationMessage from '@/shared/mixins/notificationMessage.mixin.ts';

// Filters
import formatPhone from '@/shared/filters/formatPhone.filter.ts';

// Models
import {Client, ClientStatus} from '@/manager/client/client.model';

// Constants
import Assets from '@/constants/assets';
import Endpoints from '@/constants/endpoints';
import Constants from '@/constants/constants';
import UtilsService from '@/core/services/utils.service';

// Services
import {ConvocationService} from '@/manager/convocation/convocation.service';

interface MixinInterface
    extends WithPagination,
        NotificationMessage,
        SearchMixin {
}

const all = {id: 0, text: 'Todos', queryParam: '', value: ''};
const potential = {
    id: 1,
    text: 'Potencial',
    queryParam: 'status',
    value: ClientStatus.Potential,
};
const client = {
    id: 2,
    text: 'Cliente',
    queryParam: 'status',
    value: ClientStatus.Customer,
};
const tlp = {id: 3, text: 'TLP', queryParam: 'top_level_pack', value: 1};
const certified = {
    id: 4,
    text: 'CN3',
    queryParam: 'level_3_certificate',
    value: 1,
};

@Component({
    components: {
        Icon,
        Btn,
        EmptyState,
        Search,
        ItemThumb,
        TopBar,
        Spinner,
        ParticipantClientCsvModal,
        Pagination,
        ClientFilter,
        SpotlightText,
    },
    computed: {
        ...mapGetters({
            clientList: 'getClientList',
            getSearchString: 'getSearchString',
            getClientPaginationInfo: 'getClientPaginationInfo',
        }),
    },
    methods: {
        ...mapActions({
            uploadConvocationCSV: 'uploadConvocationCSV',
        }),
    },
    filters: {
        formatPhone,
    },
})
export default class ClientList extends Mixins<MixinInterface>(
    WithPagination,
    NotificationMessage,
    SearchMixin,
) {
    private alertDisplace = false;
    private cleanSearch = false;
    private btnPredefinedStyle = BtnPredefinedStyle;
    private clientList!: any;
    protected searchNifString:any= '';
    private getSearchString!: any;
    private uploadConvocationCSV !: any;
    private getClientPaginationInfo!: any;
    private btnColor = BtnColor;
    private btnWidth = BtnWidth;
    private iconEnum = IconEnum;
    private assets = Assets;
    private filterObject = {};
    private clientListLoaded = false;
    private loadData = true;
    private spotlightTextColor = SpotlightTextColor;
    // private dropdownWidth = DropdownWidth;
    private clientTypeSelected = all;
    private filterState = false;

    @Watch('nextPage')
    private watchNextPage(activePage: any) {
        if (activePage) {
            this.addPaginationOption({activePage});
        }
    }

    @Watch('limit')
    private watchLimit(limit: any) {
        this.addPaginationOption({limit});
    }

    @Watch('action')
    private watchAction(action: any) {
        this.addPaginationOption({action});
    }

    @Watch('searchNifString')
    private watchSearchNifStringClientList(newVal: string, oldVal: string) {
        if (this.loadData) {
            const tempRemainingTime = this.remainingTime;
            if (newVal === '') {
                this.remainingTime = 0;
            }
            clearTimeout(this.searchTimeout);
            this.searchTimeout = setTimeout(() => {
                this.searchCallback();
                this.remainingTime = tempRemainingTime;
            }, this.remainingTime);
        }
    }

    @Watch('searchString')
    public watchSearchString(newVal: string, oldVal: string) {
        if (this.loadData) {
            const tempRemainingTime = this.remainingTime;
            if (newVal === '') {
                this.remainingTime = 0;
            }
            clearTimeout(this.searchTimeout);
            this.searchTimeout = setTimeout(() => {
                this.$store.dispatch('setSearchString', newVal).then();
                this.searchCallback();
                this.remainingTime = tempRemainingTime;
            }, this.remainingTime);
        }
    }

    private addPaginationOption(value: any) {
        this.$store.dispatch('addClientPaginationInfoOption', value);
    }

    get participantClientModalOpened() {
        return !!this.$route.query['client-uploaded-details']
    }

    private setParticipantClientModalOpened() {
        this.$router.push(this.$route.path)
    }

    private participantClientCsvError(message: string) {
        this.showNotification(message, this.spotlightTextColor.Error);
    }

    private created() {
        if (this.getClientPaginationInfo) {
            this.loadData = false;
            this.clientListLoaded = this.clientList.length > 0;
            this.searchString = this.getSearchString || '';
            this.onFetchSuccess(this.getClientPaginationInfo);
            setTimeout(() => {
                this.loadData = true;
            }, 100);
        }
        // this.fetchList();
    }

    get showPagination() {
        return (
            this.clientListLoaded && !this.spinner.show && this.clientList.length > 0
        );
    }

    get showEmptyState() {
        return (
            this.clientListLoaded &&
            !this.spinner.show &&
            this.clientList.length === 0
        );
    }

    private searchKeyUp() {
        this.filterState = false;
    }

    private updateClientList() {
        this.filterState = false;
        this.fetchFirstPageList();
    }

    // get clientOptions(): any[] {
    //     return [
    //         all,
    //         potential,
    //         client,
    //         tlp,
    //         certified,
    //     ];
    // }

    get numberOfClients() {
        let measure = 'clientes';
        if (this.clientList.length === 1) {
            measure = 'cliente';
        }
        return `${this.clientList.length} ${measure}`;
    }

    private async importClients() {
        
        const clients = await ConvocationService.uploadCsv();
        
        const message = await this.uploadConvocationCSV({
            file: clients,
            url: Endpoints.clientImport
        });
        
        this.showMessage({message});
    }

    public exportCsvExample() {
        ConvocationService.downloadCsvByLocalUrl("/csv-examples/Plantilla_Clientes.csv");
    }

    private exportClientList() {
        if (!this.exportDisabled) {
            const payload = {
                queryParams: {
                    limit: Constants.downloadCsvLimit,
                    search: this.searchString,
                    ...this.getClientTypeQueryParam,
                    ...this.filterObject,
                },
            };
            let params = UtilsService.getQueryParams(payload);
            params = UtilsService.getQueryParamsFormatted(params);
            this.$store
                .dispatch('sendClientListToMail', params)
                .then((res) => {
                    this.showMessage({
                        message:
                            'Se ha enviado un correo con la lista filtrada de clientes.',
                    });
                })
                .catch((err) => {
                    this.showMessage({
                        message: 'Hemos tenido un problema intentelo mas tarde.',
                        error: true,
                    });
                });
        }
    }

    private showMessage(message: any) {
        let color = this.ownSpotlightTextColor.Primary;
        let text = message;
        if (message.error) {
            color = this.ownSpotlightTextColor.Error;
        }
        if (message.message) {
            text = message.message;
        }
        this.showNotification(text, color);
    }

    get getClientTypeQueryParam() {
        const param: any = {};
        param[this.clientTypeSelected.queryParam] = this.clientTypeSelected.value;
        return param;
    }

    private clientActive(client: Client) {
        return (client.user as any).isActive;
    }

    private clientName(client: Client) {
        const user = client.user as any;
        if (!client.nickname) {
            return `${user.firstName} ${user.lastName}`;
        }
        return `${user.firstName} ${user.lastName} (${client.nickname})`;
    }

    private isTLP(client: Client) {
        return client.topLevelPack;
    }

    private isPWP(client: Client) {
        return client.powerPack;
    }

    private isOldTLP(client: Client) {
        return client.oldTopLevelPack;
    }

    private isCertificate(client: Client) {
        return client.level_3_certificate;
    }

    private subtitleIcon(client: Client) {
        let icon = '';
        if (client.topLevelPack || client.oldTopLevelPack) {
            icon = this.iconEnum.TopLevelPack;
        } else if (client.powerPack) {
            icon = this.iconEnum.PowerPack;
        } else if (client.level_3_certificate) {
            icon = this.iconEnum.Certificate;
        }
        return icon;
    }

    private clientEmail(client: Client) {
        return (client.user as any).email;
    }

    private clientAvatar(client: Client) {
        let avatar = this.assets.defaultAvatar;
        const profile = (client as any).user.profile;
        if (profile !== null && profile.avatar !== null) {
            avatar = profile.avatar;
        }
        return avatar;
    }

    private clientPhone(client: Client) {
        let phone = '';
        const profile = (client.user as any).profile;
        if (profile !== null && profile.phone !== null) {
            phone = profile.phone;
        }

        return phone;
    }

    private fetchClientList(
        callback: any = () => {
            const doNothing = 1;
        },
    ) {
        const payload = {
            queryParams: {
                offset: this.offset,
                limit: this.limit,
                search: this.searchString,
                searchNif: this.searchNifString,
                ...this.getClientTypeQueryParam,
                ...this.filterObject,
            },
        };
        this.$store.dispatch('fetchClientList', payload).then((res) => {
            callback(res);
        });
    }

    public fetchList() {
        this.changeSpinnerVisibility(true);
        this.fetchClientList((res: any) => {
            this.onFetchSuccess(res);
            this.clientListLoaded = true;
            this.changeSpinnerVisibility(false);
        });
    }

    get exportDisabled() {
        try {
            return !this.searchString && Object.keys(this.filterObject).length === 0;
        } catch (_) {
            console.error('exportDisabled() function in client list ', _);
            return true;
        }
    }

    public searchCallback() {
        this.fetchFirstPageList();
    }

    public handleComeBack() {
        this.cleanSearch = !this.cleanSearch;
        this.searchString = '';
        this.searchNifString = '';
    }

    private topBarScrolled(scrolled: boolean) {
        this.alertDisplace = scrolled;
    }

    private addButtonClick() {
        this.$router.push({name: 'clientEdit', params: {id: 'new'}});
    }
}
